import { Modal } from "antd";
import React, { useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { getSrcValue } from "../../../Pages/HealthsyServices/MedicineList/utils";

const ViewPhotoModal = ({
  openPhotoModal,
  setopenPhotoModal,
  imageArray,
  imageIndex = 0,
  setImageIndex,
}) => {
  const [count, setCount] = useState(0);

  const handleClose = () => {
    setopenPhotoModal(false);
    setCount(0);
  };

  return (
    <Modal
      // title="Upload Summary"
      open={openPhotoModal}
      onCancel={handleClose}
      footer={null}
      closeIcon={<IoCloseCircleOutline size={24} />}
      width={404}
    >
      <div style={{ textAlign: "center", padding: "40px 0" }}>
        <img
          src={getSrcValue(
            "medicines",
            imageIndex > 0 ? imageArray[imageIndex] : imageArray[count],
          )}
          alt="med"
          style={{
            width: "213px",
            height: "271px",
          }}
        />
      </div>

      <span className="d-flex gap-4">
        {imageArray.map((item, index) => {
          return (
            <div style={{ position: "relative", display: "inline-block" }}>
              {index === 0 && <div className="cover-label fs14fwb">Cover</div>}
              <img
                src={getSrcValue("medicines", item)}
                alt="med"
                width={80}
                height={100}
                className="p-1"
                onClick={() => {
                  setCount(index);
                  setImageIndex(0);
                }}
                style={{
                  cursor: index !== count ? "pointer" : "default",
                  border:
                    index === count ? "1px solid #cb1b5b" : "1px solid #ccc",
                  borderRadius: "9.6px",
                }}
              />
            </div>
          );
        })}
      </span>
    </Modal>
  );
};

export default ViewPhotoModal;
